import { useGetPointCentralStatus } from './get-point-central-status'

// Note: shared by every surface that needs to know whether a building's Point Central
// integration is actually usable right now — Places → Integrations (the connection status
// pill, via `use-point-central-connection.ts`) and the resident profile's Keyless Access tab
// (both designs), which used to trust a static `pointCentralAvailable` building flag with no
// live check at all.
export const useIsPointCentralBuildingConnected = (buildingId: number) => {
  const { data, isLoading, isSuccess } = useGetPointCentralStatus({ buildingId })

  return {
    isBuildingConnected: isSuccess && Boolean(data?.isConnected),
    isLoading,
  }
}
